import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var overlayStyle = createRuntimeFn({defaultClassName:'fx_e395032e_19epc5k2',variantClassNames:{overlayTheme:{light:'fx_e395032e_19epc5k3',dark:'fx_e395032e_19epc5k4',transparent:'fx_e395032e_19epc5k5'}},defaultVariants:{},compoundVariants:[]});

export { overlayStyle };
//# sourceMappingURL=overlay.vanilla.mjs.map
